import React from 'react';
import './App.css';
import TherapyLanding from './components/TherapyLanding';

function App() {
  return (
    <div className="App">
      <TherapyLanding />
    </div>
  );
}

export default App;